import React from 'react';

const StatCard = ({ icon: Icon, label, value, trend, trendUp, iconColor, bgColor }) => {
  return (
    <div className="bg-white rounded-xl p-6 border border-slate-200 hover:shadow-lg transition-shadow duration-200" data-testid={`stat-card-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start gap-4">
        <div className={`p-3 ${bgColor} rounded-lg`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        <div className="flex-1">
          <p className="text-sm text-slate-600 mb-1 uppercase tracking-wider">{label}</p>
          <p className="text-3xl font-bold text-slate-900 mb-1">{value}</p>
          {trend && (
            <p className={`text-sm ${
              trendUp ? 'text-emerald-600' : 'text-slate-500'
            }`}>
              {trend}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
